import React from 'react';
import {Helmet} from "react-helmet";
import { NavLink } from 'reactstrap'
import { Link } from 'react-router-dom'
import Gerisayim from '../../gerisayim/Gerisayim'
import LogoSlider from '../../logoSlider/LogoSlider';
import HaberSlider from '../../haberSlider/HaberSlider';
import Konusmacilar from '../../konusmacilar/Konusmacilar';
import Etkinlikler from '../../etkinlikler/Etkinlikler';
import SliderCarousel from '../../slider/SliderCarousel';


export default function Anasayfa()
{
  const title = "Orta Karadeniz Kariyer Fuarı - Samsun Üniversitesi";
  const description = "2024 yılı Orta Karadeniz Kariyer Fuarı (OKAF) hakkında en güncel bilgilere ve haberlere ulaşmak için hemen tıklayınız!";
  return (
    <>
      <Helmet>
          <title>{title}</title>
          <meta name="description" content={description} />
      </Helmet>

      <div className='container'>
        <SliderCarousel />
      </div>


      <div class="index-menu">
        <div class="color-band"></div>
        <div class="container">
          <div class="list">
            <div class="item">
              <NavLink tag={Link} to="hakkimizda">
                <p>
                  <span class="line-1"><i class="bi bi-info-circle-fill"></i></span>
                  <span class="line-2">Fuar Tanıtımı</span>
                </p>
              </NavLink>
            </div>
            <div class="item">
              <NavLink tag={Link} to="fuaryeri">
                <p>
                  <span class="line-1"><i class="bi bi-geo-alt-fill"></i></span>
                  <span class="line-2">Fuar Yeri</span>
                </p>
              </NavLink>
            </div>
            <div class="item">
              <NavLink tag={Link} to="kayitol">
                <p>
                  <span class="line-1"><i class="bi bi-node-plus-fill"></i></span>
                  <span class="line-2">Fuar Kayıt</span>
                </p>
              </NavLink>
            </div>
            <div class="item">
              <a href="https://okafkatalog2024.samsun.edu.tr/" target="_blank" title="OKAF Katalog Dokümanı">
                <p>
                  <span class="line-1"><i class="bi bi-file-earmark-pdf-fill"></i></span>
                  <span class="line-2">Katalog</span>
                </p>
              </a>
            </div>
            <div class="item">
              <a href="/assets/toplu-program.pdf?v=3" target="_blank">
                <p>
                  <span class="line-1"><i class="bi bi-file-earmark-pdf-fill"></i></span>
                  <span class="line-2">Fuar Programı</span>
                </p>
              </a>
            </div>
            <div class="item">
              <a href="https://yetenekkapisi.org/" target="_blank">
                <p>
                  <span class="line-1"><i class="bi bi-person-plus-fill"></i></span>
                  <span class="line-2">Yetenek Kapısı</span>
                </p>
              </a>
            </div>
          </div>
        </div>
      </div>

      <Gerisayim />

      <HaberSlider adet="20"></HaberSlider>

      <Konusmacilar />

      <Etkinlikler />

      <LogoSlider />


      <div class="sayilarla-okaf">
        <div class="container">
          <div className='homeTitle'>SAYILARLA OKAF</div>
          <div class="row">
            <div class="col">
              <div class="box">
                <div class="head">
                  <span class="icon"><i class="bi bi-bank2"></i></span>
                  <span class="number">9</span>
                </div>
                <div class="body">
                  <span class="name">Paydaş Üniversiteler</span>
                </div>
              </div>
            </div>
            <div class="col">
              <div class="box">
                <div class="head">
                  <span class="icon"><i class="bi bi-calendar-event"></i></span>
                  <span class="number">50+</span>
                </div>
                <div class="body">
                  <span class="name">Etkinlik Sayısı</span>
                </div>
              </div>
            </div>
            <div class="col">
              <div class="box">
                <div class="head">
                  <span class="icon"><i class="bi bi-building-fill-check"></i></span>
                  <span class="number">150+</span>
                </div>
                <div class="body">
                  <span class="name">Kayıtlı Firma/Kurum</span>
                </div>
              </div>
            </div>
            <div class="col">
              <div class="box">
                <div class="head">
                  <span class="icon"><i class="bi bi-award"></i></span>
                  <span class="number">60+</span>
                </div>
                <div class="body">
                  <span class="name">Sponsor Sayısı</span>
                </div>
              </div>
            </div>
            <div class="col">
              <div class="box">
                <div class="head">
                  <span class="icon"><i class="bi bi-person-fill-down"></i></span>
                  <span class="number">30000+</span>
                </div>
                <div class="body">
                  <span class="name">Beklenen Ziyaretçi</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </>
  )
}